export default __webpack_public_path__ + "static/media/302.71c93839.svg";